import React, { useState } from 'react'
import Tag from './Tag'
import CourseButton from './CourseButton'

export default function CourseCard({ tagText, CourseHeading, CourseDescription, buttonColor }) {
  const [hovered, setHovered] = useState(false)

  const cardStyle = {
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(#030C2B, #030C2B), linear-gradient(to right, #E42C64, #614AD3)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
  }

  return (
    <div
      style={cardStyle}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className='group relative flex h-full flex-col justify-between gap-10 self-stretch rounded-[15px] bg-[#030C2B] p-[24px] transition-shadow duration-300 hover:shadow-[0_20px_60px_-15px_rgba(228,44,100,0.25)]'
    >
      {/* top-edge highlight on hover */}
      <span
        aria-hidden
        className='pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-white/70 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100'
      />

      <div className='flex flex-grow flex-col gap-6'>
        <Tag color={'#4268FF'} text={tagText} />

        <div className='flex w-full flex-col gap-1'>
          <h2 className='text-left text-[16px] font-bold text-white'>{CourseHeading}</h2>
          <h4 className='text-left text-[12px] text-[#A0AEC0]'>{CourseDescription}</h4>
        </div>
      </div>
      <div className='w-full'>
        <CourseButton
          label={tagText === 'Niveau 1' ? 'Je découvre le Guide' : 'Je découvre la formation'}
          buttonColor={buttonColor}
          forceHover={hovered}
        />
      </div>
    </div>
  )
}
